<template>
    <div class="page-wrap">
        <sign-layout v-if="$route.meta.layout === 'sign'">
            <router-view />
        </sign-layout>

        <home-layout v-else>
            <router-view />
        </home-layout>

        <modal-user-agreement />
        <notification />

    </div>
</template>
<script>
import SignLayout from './modules/sign/SignLayout';
import { HomeLayout } from './modules/home/HomeLayout';
import { ModalUserAgreement } from './modules/modal/ModalUserAgreement';
import { Notification } from './modules/notification/Notification';

export default {
    name: 'app',
    components: {
        ModalUserAgreement,
        Notification,
        HomeLayout,
        SignLayout,
    },
}
</script>



// WEBPACK FOOTER //
// App.vue?abcd23d2